import { ResponsivePie } from '@nivo/pie'

import { Pie } from 'components/Tooltip'

import { settings } from 'styles'

const PieChart = props => (
  <div className='full'>
    <ResponsivePie {...{ ...settings, ...props }} tooltip={Pie} />
  </div>
)

export default PieChart
